const resetRuleFields = async (form, state) => {
  await form.resetFields();
  await state.setAllowEdit(false);
  state.setInputSourceFileData(undefined);
  state.setConfigFields({});
  state.setXmlStructure('');
};

export default resetRuleFields;
